var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410,
    height: 90,
    viewBox: "0 0 410 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -4) scale(.9)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21H65V55H5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 32H83L96 46V59H70Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 37H81L88 46H75Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 27V48M25 27V48M35 27V48M45 27V48M55 27V48",
    stroke: "#000",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 62,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 62,
    r: 6.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 62,
    r: 7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 91C29 76 60 74 98 78V87C61 83 32 84 3 98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 87L27 84M40 81L50 80M64 80H75M87 82H96",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.2
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#1062B9",
    mask: "url(#mark)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 105,
    y: 57,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 40,
    letterSpacing: -1.4,
    fill: "#1062B9"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 400
  }, "Smart"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700
  }, " Transport"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStLogo);
export default __webpack_public_path__ + "static/media/st-logo.79758a0681724dbce3482641cbeae250.svg";
export { ForwardRef as ReactComponent };